export default __webpack_public_path__ + "static/media/bg.7ba36775.webp";